import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const TableRoot = styled.table(props => ({
    tableLayout: "fixed",
    width: 0,
    borderCollapse: "collapse",
    borderWidth: 0,
    borderColor: theme(props).border.color,

    td: {
        padding: "20px 5px 0",
        fontSize: theme(props).typography.primary.fontSize.css(),
        lineHeight: "22px",
        whiteSpace: "normal",
    },
}));
